import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useUnclaimOrder = ({
  orderId,
  onSuccess,
  onError,
}: {
  orderId: string;
  onSuccess: () => void;
  onError: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: () => OrdersClient.unclaimOrder(orderId),
    onSuccess,
    onError,
  });

  return {
    unclaimOrder: mutate,
    isPending,
  };
};
